import React from "react"
import Portal from "@reach/portal"
import toast, { Toaster } from "react-hot-toast"
import styles from "./styles.module.scss"

const useCustomToast = (position = "top-center") => {
  const Toast = () => {
    return (
      <Portal>
        <Toaster toastOptions={{ duration: 3000, position: position }} />
      </Portal>
    )
  }

  const Message = ({ message }) => {
    const { title, description } = message

    return (
      <div className={styles.toast}>
        <p style={{ margin: description ? "0 0 0.5rem 0" : "0" }}>{title}</p>

        {Array.isArray(description) ? (
          <ul className={styles.list}>
            {description.map((item) => {
              return (
                <li key={item} dangerouslySetInnerHTML={{ __html: item }} />
              )
            })}
          </ul>
        ) : description ? (
          <p>{description}</p>
        ) : null}
      </div>
    )
  }

  const notifyMessage = (message) => {
    const { type } = message

    if (type === "success") {
      toast.success(<Message message={message} />, {
        style: {
          border: "1px solid #10B981",
          padding: "16px",
          color: "#10B981",
          background: "#ECFDF5",
        },
        iconTheme: {
          primary: "#10B981",
          secondary: "#ECFDF5",
        },
      })
    } else if (type === "error") {
      toast.error(<Message message={message} />, {
        style: {
          border: "1px solid #EF4444",
          padding: "16px",
          color: "#EF4444",
          background: "#FEF2F2",
        },
        iconTheme: {
          primary: "#EF4444",
          secondary: "#FEF2F2",
        },
      })
    } else {
      toast(<Message message={message} />, {
        style: {
          border: "1px solid #3B82F6",
          padding: "16px",
          color: "#3B82F6",
          background: "#EFF6FF",
        },
        iconTheme: {
          primary: "#3B82F6",
          secondary: "#EFF6FF",
        },
      })
    }
  }

  return [Toast, notifyMessage]
}

export default useCustomToast
